import { render, staticRenderFns } from "./diynotice.vue?vue&type=template&id=5402410e&scoped=true&"
import script from "./diynotice.vue?vue&type=script&lang=js&"
export * from "./diynotice.vue?vue&type=script&lang=js&"
import style0 from "./diynotice.vue?vue&type=style&index=0&id=5402410e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5402410e",
  null
  
)

export default component.exports